import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M12.75 3.75v16.5c0 .398-.352.75-.75.75a.77.77 0 0 1-.75-.75V3.75c0-.398.352-.75.75-.75s.75.352.75.75M9 11.25H3.31l1.72-1.72a.77.77 0 0 0 0-1.06.77.77 0 0 0-1.06 0l-3 3a.76.76 0 0 0-.22.53c0 .197.08.391.22.53l3 3a.77.77 0 0 0 1.06 0 .77.77 0 0 0 0-1.06l-1.72-1.72H9c.398 0 .75-.352.75-.75a.77.77 0 0 0-.75-.75m14.03.22-3-3a.77.77 0 0 0-1.06 0 .77.77 0 0 0 0 1.06l1.72 1.72H15a.77.77 0 0 0-.75.75c0 .398.352.75.75.75h5.69l-1.72 1.72a.77.77 0 0 0 0 1.06.77.77 0 0 0 1.06 0l3-3c.14-.139.22-.333.22-.53a.76.76 0 0 0-.22-.53" />
  </>
);

const Split = Icon('split', svgContents);

export default Split;
